import gql from 'graphql-tag';

const leaderboardEntryFields = `
	fullName
	isUser
	position
	totalPoints
`;

export const GetUserStatsAndRankings = gql`
	query GetUserStatsAndRankings($userId: ID!) {
		getUserStatsAndRankings(userId: $userId) {
			userId
			companyId
			currency
			skipped
			errors {
				message
				option
			}
			rankings {
				pointsRanking
				previousRanking
				ranking
			}
			stats {
				bonusTotal
				openJobTotal
				referralTotal
				referralPointsTotal
				recognitionPointsTotal
				recognitionTotal
				referralTotalLeaderboard {
					${leaderboardEntryFields}
				}
				referralPointsLeaderboard {
					${leaderboardEntryFields}
				}
				recognitionPointsLeaderboard {
					${leaderboardEntryFields}
				}
				recognitionPointsBySubCompanyLeaderboard {
					${leaderboardEntryFields}
				}
			}
		}
	}
`;
